
import { Component, ReactNode } from 'react'
import { withRouter } from "react-router-dom";
import {RouteComponentProps} from "react-router";

interface IProps {
  location: Location
}

class Redirecting extends Component<IProps & RouteComponentProps> {
  constructor (props: Readonly<IProps & RouteComponentProps>) {
    super(props)
    this.state = { ...props }
  }

  componentDidMount () {
    window.location.href = this.props.location.pathname + this.props.location.search
  }

  public render (): ReactNode {
    return null
  }
}

export default withRouter(Redirecting)
